export enum ActivityEvents {
  CREATED = 'created',
  UPDATED = 'updated',
  DELETED = 'deleted',
}

export const ActivityEventLabels = {
  [ActivityEvents.CREATED]: 'Criação',
  [ActivityEvents.UPDATED]: 'Edição',
  [ActivityEvents.DELETED]: 'Exclusão',
}
